// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "storage/static/js/" + chunkId + "." + "c0824d3f" + ".chunk.js";
};